import { request } from '@/utils/request'

export function sendCode(data) {
  return request({
    url: '/api/index/sendCode',
    method: 'post',
    data: data
  })
}

export function login(data) {
  return request({
    url: '/api/index/login',
    method: 'post',
    data: data
  })
}

export function userInfo(data) {
	return request({
		url: '/api/loan/userInfo',
		method: 'POST',
		data
	},true, true)
}

export function userStepData(data) {
	return request({
		url: '/api/user/getStepInfo',
		method: 'POST',
		data
	}, true, true)
}

export function cfgIndex() {
	return request({
		url: '/api/index/getConfigForFront',
		method: 'POST'
	})
}



// WEBPACK FOOTER //
// ./src/api/info.js